import {
  sendBroadcast,
  sendBroadcastFailure,
  sendBroadcastSuccess,
} from '@reducers/whatsAppSendBroadcast.reducer';
import { PayloadAction } from '@reduxjs/toolkit';
import { sendBroadcastGET } from '@services/whatsappBroadcast.service';
import { call, put, takeLeading } from 'redux-saga/effects';

function* sendBroadcastSaga(
  action: PayloadAction<{
    botAccountId: number;
    auditId: string;
    scheduledAt?: string;
  }>
) {
  try {
    const response: { errorCode?: string } = yield call(
      sendBroadcastGET,
      action.payload
    );

    if (response?.errorCode) {
      yield put(
        sendBroadcastFailure({
          message: response.errorCode,
          errorCode: response.errorCode,
        } as never)
      );
    } else {
      yield put(sendBroadcastSuccess({ broadcastId: action.payload.auditId }));
      // Save broadcast Id in localStorage
      window.localStorage.setItem('broadcastId', action.payload.auditId);
    }
  } catch (error) {
    yield put(
      sendBroadcastFailure({
        message: 'UNKNOWN_ERROR',
        errorCode: 'UNKNOWN_ERROR',
      } as never)
    );
  }
}

export default function* whatsAppSendBroadcastSaga() {
  yield takeLeading(sendBroadcast.type, sendBroadcastSaga);
}
